import { useProfilePicture } from "hooks/useProfilePicture";

export type ProfilePictureProps = {
    width: number | string;
    height: number | string;
    additionalStyles?: React.CSSProperties;
    fallbackSize?: number | string | undefined;
    /** Local preview URL before upload is saved. */
    overrideSrc?: string | null;
    /** When set and the user has no picture, render initials of this name instead of the generic icon. */
    initialsFrom?: string;
}

export function getInitials(name: string): string {
    return name
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part.charAt(0).toLocaleUpperCase('tr-TR'))
        .join('');
}

export default function ProfilePicture({
    width,
    height,
    additionalStyles,
    fallbackSize,
    overrideSrc,
    initialsFrom,
}: ProfilePictureProps) {
    const { rawUrl, hasProfilePicture } = useProfilePicture();
    const displayUrl = overrideSrc ?? rawUrl;
    const showImage = Boolean(overrideSrc) || hasProfilePicture;
    const initials = !showImage && initialsFrom ? getInitials(initialsFrom) : '';

    if (initials) {
        return (
            <div
              className="sb-avatar-initials rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
              style={{ width: width, height: height, ...additionalStyles }}
              aria-hidden="true"
            >
                {initials}
            </div>
        )
    }

    if (!showImage) {
        return (
            <div
              className="rounded-circle bg-light d-flex align-items-center justify-content-center text-secondary flex-shrink-0"
              style={{ width: width, height: height, ...additionalStyles }}
            >
                <i className={`fas fa-user ${fallbackSize ? `fa-${fallbackSize}` : ''}`} />
            </div>
        )
    }
    return (
        <img
            alt="Kullanıcı"
            className="rounded-circle object-fit-cover"
            height={height}
            width={width}
            src={displayUrl!}
            style={{ objectFit: 'cover', width: width, height: height, ...additionalStyles }}
        />
    )
}
